export const PILA_MESSAGE_ERROR = 'Antes de transmitir la nómina debe liquidar y obtener el valor de seguridad social.';
